import React from 'react';
import SpanSpinner from '../../../Shared/SpanSpinner/SpanSpinner';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './AccountCreate.scss';
import { Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { createAccount } from '../../../../Redux/Actions/AccountCreateActions';
import { loader, toastr } from '../../../../Redux/Actions/CommonActions';
import { validationService } from '../../../../services/validation.service';
import { NavLink } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Alert } from 'reactstrap';

class AccountCreate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            passwordConfirm: '',
            emailError: '',
            passwordError: '',
            confirmPasswordError: '',
            visible: true
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name; 
        this.setState({ [name]: value });

        if (name === 'email') {
            this.validateEmail(value);
        } 

        if (name === 'password')
            this.validatePassword(value);

        if (name === 'passwordConfirm')
            this.validateCOnfirmPassword(value);
    }

    validatePassword = (val) => {
        const passwordValidation = `Passwords must be between 6 and 18 characters, 
                                    have at least one non-alphanumeric character, 
                                    one digit ('0'-'9'), 
                                    one uppercase ('A'-'Z'), and 
                                    one lowercase ('a'-'z').`;

        var validPassword = validationService.isValidPassword(val);
        this.setState({ passwordError: validPassword ? '' : passwordValidation});
        return validPassword;
    }

    validateCOnfirmPassword = (val) => {
        var validPassword = this.state.password === val;
        this.setState({ confirmPasswordError: validPassword ? '' : "Passwords do not match!"});
        return validPassword;
    }

    validateEmail = (val) => {
        const emailErrorMessage = 'Valid email address is required';
        if (!validationService.isValidEmail(val)){
            this.setState({emailError: emailErrorMessage });
            return false;
        }
        this.setState({emailError: '' });
        return true;
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.validateEmail(this.state.email) &&
            this.validatePassword(this.state.password) &&
            this.validateCOnfirmPassword(this.state.passwordConfirm)) {
                const { dispatch } = this.props;
            this.props.createAccount(this.state.email, this.state.password);
        }
    }

    render() {
        return (
            <div>
                <div className="create-account">
                    {this.props.error? (
                        <Alert
                            color="red"
                            isOpen={this.state.visible}
                            style={{ position: 'fixed', width: '100%', color: 'white', backgroundColor: "#ff4444", textAlign: 'center' }}
                        >
                            {this.props.error}
                        </Alert>
                    ) : null}
                    <div className="create-account-content">
                        <div>
                            <h1 className="text-left">Sign up for New Membership</h1>
                            <p className="text-left">To create your account, please enter your email address and a password.</p>
                            <form onSubmit={this.handleSubmit} className="padding">
                                <FormGroup>
                                    <Label htmlFor="emailInput" xs={12}>Email</Label>
                                    <Col xs={12}>
                                        <Input 
                                            type="email" 
                                            name="email" 
                                            id="emailInput"
                                            onChange={this.handleInputChange}
                                            value={this.state.email}
                                            placeholder="Email Address"
                                            invalid ={ this.state.emailError ? true : false } />
                                        <FormFeedback>{this.state.emailError}</FormFeedback>
                                    </Col>
                                </FormGroup>
                                <br />
                                <FormGroup>
                                    <Label htmlFor="passwordInput" xs={12}>Password</Label>
                                    <Col xs={12}>
                                        <Input 
                                            type="password" 
                                            name="password" 
                                            id="passwordInput" 
                                            value={this.state.password}
                                            minLength={6}
                                            maxLength={18}
                                            onChange={this.handleInputChange}
                                            invalid ={ this.state.passwordError ? true : false }
                                            placeholder="Password" />
                                            <FormFeedback>{this.state.passwordError}</FormFeedback>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="confirmInput" xs={12}>Confirm Password</Label>
                                    <Col xs={12}>
                                        <Input 
                                            type="password" 
                                            name="passwordConfirm"
                                            className="form-control" 
                                            id="confirmInput" 
                                            value={this.state.passwordConfirm}
                                            onChange={this.handleInputChange}
                                            invalid ={ this.state.confirmPasswordError ? true : false }
                                            placeholder="Confirm Password" />
                                            <FormFeedback>{this.state.confirmPasswordError}</FormFeedback>
                                    </Col>
                                </FormGroup>
                                <br />
                                <FormGroup>
                                    <div className="v-space"></div>
                                    <button className='btn btn-primary btn-block btnPrimary' type="submit">
                                        {
                                            this.props.submitting
                                        ? <SpanSpinner message="Submitting..." />
                                            : <span>Submit</span>
                                        }
                                    </button>
                                </FormGroup>

                                <FormGroup>
                                    <div className="v-space"></div>
                                    <NavLink tag={RouterNavLink} className="btn btn-cancel btnPrimary" to="/home">Cancel</NavLink>
                                </FormGroup>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { submitting, error } = state.createAccount;
    return {
        submitting,
        error
    };
}

export default withRouter(connect(mapStateToProps, { toastr, createAccount })(AccountCreate));

